const getLocation = () => {
  return window.location
}

/**
 * Returns URL with Params
 * @param params {[key: string]: unknown} Key-Value Object
 * @param urlForChange {string} Target URL. Empty -> Current
 */
export const getUrlWithParams = (params: { [key: string]: unknown }, urlForChange?: string) => {
  const url = (urlForChange || getLocation().pathname).split('?')[0].split('/')
  const newUrl = url.filter(Boolean)
  let newStringUrl = ''
  for (let i = 0; i < newUrl.length; i++) {
    if (params[newUrl[i]]) {
      newStringUrl = `${newStringUrl}/${newUrl[i]}/${params[newUrl[i]]}`
      i++
    } else {
      newStringUrl = `${newStringUrl}/${newUrl[i]}`
    }
  }

  Object.keys(params).forEach((p) => {
    if (newStringUrl.indexOf(`/${p}/`) === -1 && newStringUrl.indexOf(`${p}/`) !== 0) {
      if (p === 'locale') {
        newStringUrl = `/${p}/${params[p]}${newStringUrl}`
      } else {
        newStringUrl = `${newStringUrl}/${p}/${params[p]}`
      }
    }
  })
  return newStringUrl + (!newStringUrl.includes('?') ? getLocation().search : '')
}

/**
 * Return URL that contains all but given params
 * @param params {string[]} param keys
 * @param urlForChange {string} Target URL. Empty -> Current
 */
export const deleteParamsFromUrl = (params: string[], urlForChange?: string) => {
  const url = (urlForChange || getLocation().pathname).split('?')[0].split('/')
  const newUrl = url.filter(Boolean)
  let newStringUrl = ''
  for (let i = 0; i < newUrl.length; i++) {
    if (params.indexOf(newUrl[i]) > -1) {
      i++
    } else {
      newStringUrl = `${newStringUrl}/${newUrl[i]}`
    }
  }
  return newStringUrl + getLocation().search
}

export const arrayToObject = (params: string[]) => {
  const result = {}
  for (let i = 0; i < params.length; i++) {
    if (params[i]) {
      result[params[i]] = params[i + 1]
      i++
    } else {
      break
    }
  }
  return result
}

/**
 * Returns Param value
 * @param pName {string} param key
 * @param url {string}
 */
export const getUrlParam = (pName: string, url?: string) => {
  const params = getUrlParams(url)
  return params[pName] ? decodeURI(params[pName]) : params[pName]
}

export const getUrlParams = (url?: string) => {
  const params = (url || getLocation().pathname).split('?')[0].split('/')
  // .filter((element: string) => {
  //   return !(import.meta.env.VITE_PUBLIC_URL || '').includes(element)
  // })
  const newUrl = params.filter(Boolean).map((el) => {
    return decodeURI(el)
  })
  return arrayToObject(newUrl)
}
